import React, { useEffect, useState } from "react";

const UserAgreementPopup: React.FC = () => {
    const [isAgreementAccepted, setIsAgreementAccepted] = useState<boolean>(false);

    // Sayfa yüklenince localStorage kontrolü
    useEffect(() => {
        const agreementAccepted = localStorage.getItem("AgreementApprovalChat") === "true";

        setIsAgreementAccepted(agreementAccepted);
    }, []);

    // Onay butonuna basılınca localStorage'a 'true' değeri ekler
    const handleAgreement = () => {
        localStorage.setItem("AgreementApprovalChat", "true");

        setIsAgreementAccepted(true);

        // Storage event'ini manuel tetikle
        window.dispatchEvent(new Event('storage'));
    };

    // Eğer onay verilmişse popup'ı gösterme
    if (isAgreementAccepted) return null;

    return (
        <div className="fullscreen-popup">
            <div className="popup-content">

                <div className="icon-container">
                    <img src="/images/sozlesme-icon.svg" alt="Sözleşme İkonu" />
                </div>
                <div className="popup-texts">
                    <h3 className="popup-title">Sözleşme Onayı</h3>
                    <p className="popup-desc">
                        Lütfen aşağıdaki sözleşmeyi okuyup onaylayınız. Devam etmek için sözleşmeyi kabul etmeniz gerekmektedir.
                    </p>
                    <div className="col-12 text-center mb-2">
                        <a rel="noopener noreferrer" href="https://www.happ.health/pages/hizmetsozlesmesi">
                            Hizmet Sözleşmesi
                        </a>
                    </div>
                    <div className="col-12 text-center mb-2">
                        <a rel="noopener noreferrer" href="https://www.happ.health/pages/kvkk">
                            Kişişel Verilerin İşlenmesine İlişkin Açık Rıza Metni
                        </a>
                    </div>
                </div>

                <div className="button-container">
                    <button className="btn btn-approve" onClick={handleAgreement}>
                        Onayla
                    </button>
                </div>
            </div>
        </div>
    );
};

export default UserAgreementPopup;
